import script from "./HelpComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpComponent.vue?vue&type=script&setup=true&lang=js"

import "./HelpComponent.vue?vue&type=style&index=0&id=1d0d3a9d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d0d3a9d"]])

export default __exports__